import {LeadFormDialogData} from '@app/product/services/lead.service';
import {FormDataTrackingService} from '@app/services/analytics/form-data-tracking.service';
import {ActionTypeStrategy, DcpBundleTemplate, TransactionListCta, TransactionType} from '@dcp/configurator';
import {Product} from '@spartacus/core';
import {LAUNCH_CALLER, LaunchDialogService} from '@spartacus/storefront';

export class PopupActionTypeStrategy implements ActionTypeStrategy {

  constructor(
    private launchDialogService: LaunchDialogService,
    private formDataTrackingService: FormDataTrackingService,
    private transactionType: TransactionType,
    private transactionListCta: TransactionListCta,
    private product: Product,
    private bundleTemplate: DcpBundleTemplate,
  ) {
  }

  public action(): void {
    this.launchDialogService.openDialogAndSubscribe(
      LAUNCH_CALLER.LEAD_FORM,
      undefined,
      {
        transactionListCta: this.transactionListCta,
        transactionType: this.transactionType,
        product: this.product,
        bundleTemplate: this.bundleTemplate,
        formName: this.formDataTrackingService.generateFormName(
          this.transactionType.adobeFormType,
          this.product
        )
      } as LeadFormDialogData
    );
  }
}
